<div class="login_p_section">
    <div class="container d-flex align-items-center vh-100">
      <div class="row w-100 align-items-center">
        <div class="col-md-6 d-none d-md-block">
          <div class="login-info">
            <div class="new_logo">
              <img src="../../../../assets/images/lookzup-business-logo.png" />
            </div>
            <p class="mt-2 dedifclass">
              Dedicated platform for the Beauty, Grooming and Fitness industry. 
              Manage business, bookings, billings, employees, payments, expenditures, customers and promotions.
               A must-have productivity tool for business owners and individual professionals. 
            </p>
            <div class="login_ttg">
              <div class="list_flex">
               <mat-icon>task_alt</mat-icon> <span>Multi lingual</span>
              </div>
              <div class="list_flex">
                <mat-icon>task_alt</mat-icon> <span>Import old data</span>
              </div>
              <div class="list_flex">
                <mat-icon>task_alt</mat-icon> <span>Express support</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div id="first-form">
            <mat-card appearance="outlined" class="card newrt p-4">
              <h4 class="mb-2 d-none d-md-block">Welcome to LookzUp</h4> <!-- Visible only on desktop -->
              <div class="login_img_section d-block d-md-none">
                <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
              </div> <!-- Visible only on mobile -->
              
              <p class="join_heading">
             z
              </p>
              <!-- login -->
              <form>
                <!-- <mat-form-field appearance="outline" class="full-width">
            <mat-label>Country</mat-label>
            <mat-select [(value)]="selectedCountry">
              <mat-option *ngFor="let country of countryList" [value]="country.code">
                <ng-container *ngIf="country.flagClass;">
                  <img [src]="country.imageUrl" alt="{{ country.name }}" class="country-flag" /> 
                  <span class="flag-icon" [ngClass]="country.flagClass"></span> {{ country.name }} (+{{ country.code }})
                </ng-container>
             
              </mat-option>
            </mat-select>
          </mat-form-field> -->
  
           
                <mat-form-field class="w-100" appearance="outline">
                  <mat-select
                    placeholderLabel="Search"
                    name="primarySelectedSpecialityCtrl"
                    [(value)]="selectedCountry"
                    (selectionChange)="onCountrySelected($event)"
                    #primarySpecialitiesSelector
                  >
                    <mat-option>
                      <ngx-mat-select-search
                        noEntriesFoundLabel="no results found"
                        name="countrysearch"
                        placeholderLabel="Enter country name"
                        [formControl]="searchString"
                        (keyup)="onKey()"
                      ></ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                      *ngFor="let country of countryList"
                      [value]="country"
                    >
                      {{ country.flag }} {{ country.name }}
                      {{ "(" + country.dial_code + ")" }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
  
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Phone Number</mat-label>
                  <input
                    matInput
                    type="tel"
                    name="phone"
                    maxlength="10"
                    [(ngModel)]="phone"
                    placeholder="Enter your phone number"
                    smNumericOnly
                  />
                </mat-form-field>
  
                <div class="verify_btn">
                  <button
                    mat-flat-button
                    color="primary"
                    class="full-width"
                    [disabled]="
                      
                      !phone || phone.length != 10"
                    #submitButton
                    (click)="onSendOTP()"
                  >
                    Verify mobile
                  </button>
                </div>
              </form>
              <p class="footer-text">
                By clicking Sign up and registering with us, you are agreeing and
                consenting to our
                <a href="https://lookzup.com/terms" target="_blank">Terms of Services</a> and
                <a href="https://lookzup.com/privacy" target="_blank" >Privacy policy</a>.
              </p>
  
              <p class="footer-text">
                Looking for beauty and grooming services for you and your family?
                <a href="https://lookzup.com" target="_blank" style="text-decoration: underline;color: #222;"
                  >Login to customer website</a
                >.
              </p>
  
              <!-- login end -->
            </mat-card>
          </div>
  
          <!-- otp start -->
          <div *ngIf="otpReceived && !showProfileForm && !toshowblockedmessage && !registrationDone">
            <mat-card appearance="outlined" class="card newrt p-4">
              <!-- <h4 class="mb-2">Welcome to LookzUp</h4> -->
              <div class="login_img_section d-block d-md-none">
                <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
              </div> 
              <p class="join_heading">
                Join the platform and manage your Salon, Parlour, Spa, and Make-up
                Studio like never before.
              </p>
              <!-- login -->
  
              <form>
                <div class="tht_sectionm">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Phone Number</mat-label>
                    <input matInput [value]="userPhoneNumber" disabled type="tel" />
                    <mat-icon matSuffix class="material-icons-outlined" (click)="onbacklogin()" style="cursor: pointer;">edit</mat-icon>
                    <!-- <button mat-icon-button matSuffix (click)="onbacklogin()">
                    </button> -->
                  </mat-form-field>
                </div>
                <div class="otp-container">
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 0)"
                    name="first"
                    [(ngModel)]="otp[0]"
                    id="box0"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 1)"
                    name="second"
                    [(ngModel)]="otp[1]"
                    id="box1"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 2)"
                    name="third"
                    [(ngModel)]="otp[2]"
                    id="box2"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 3)"
                    name="fourth"
                    [(ngModel)]="otp[3]"
                    id="box3"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 4)"
                    name="fifth"
                    [(ngModel)]="otp[4]"
                    id="box4"
                  />
                  <input
                    type="text"
                    maxlength="1"
                    class="otp-input"
                    (input)="onInput($event, 5)"
                    name="sixth"
                    [(ngModel)]="otp[5]"
                    id="box5"
                  />
                </div>
                <div class="small_tht">
                  <p>
                    Enter the verification code you received in your mobile from LookzUp platform.
                  </p>
                </div>
  
                <div class="verify_btn" (click)="onSignIn()">
                  <button mat-flat-button color="primary" class="full-width" [disabled]="checkOtpDisability()">
                    Confirm
                  </button>
                </div>
                <div class="resend_code_heading">
                  <p>
                    Haven't received any verification code yet? <a href="#" class="resend_tter">Re-send code.</a>
                  </p>
                </div>
              </form>
            </mat-card>
          </div>
  
          <div *ngIf="showProfileForm && !toshowblockedmessage && !registrationDone">
            <mat-card appearance="outlined" class="card newrt p-4">
              <div class="login_img_section d-block d-md-none">
                <img src="../../../../assets/images/lookzup-business-logo.png" alt="LookzUp Logo" />
              </div> 
              <p class="join_heading">
                Join the platform and manage your Salon, Parlour, Spa, and Make-up
                Studio like never before.
              </p>
            <form [formGroup]="signInForm">
              <ng-template matStepLabel>Profile</ng-template>
              <div class="row g-2 mb-3 justify-content-between phone-field">
                
                <mat-form-field appearance="outline" class="col-12">
                  <mat-label>Name</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="name"
                    required
                  />
                  
                </mat-form-field>
                <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()">
                    <mat-label>Date of birth</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="dob" readonly>
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                  </mat-form-field>
                  <!-- <div class="radio_group">
                    <label>Gender: </label>
                    <mat-radio-group formControlName="gender">
                      <mat-radio-button value="Male">Male</mat-radio-button>
                      <mat-radio-button value="Female">Female</mat-radio-button>
                      <mat-radio-button value="Others">Others</mat-radio-button>
                    </mat-radio-group>
                  </div> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Address</mat-label>
                    <input
                    formControlName="address"
                      matInput
                      (input)="updateSearchResults()"
                      [matAutocomplete]="auto"
                    />
                    <!-- <mat-icon matSuffix class="material-icons-outlined"
                      >person_pin_circle</mat-icon
                    > -->
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let item of autocompleteItems"
                        (click)="selectSearchResult(item)"
                      >
                        {{ item.description }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
              </div>
              
              <button
                mat-flat-button
               style="    width: 100%;
               background: #FFC107;
               border-radius: 20px;
               color: white;
               height: 45px;"
                class="w-100"
                [disabled]="signInForm.invalid"
                (click)="onRegister()"
              >
                Save and Go
              </button>
            </form>
          </mat-card>
          </div>
          <div *ngIf="toshowblockedmessage && !registrationDone">
            <mat-card appearance="outlined" class="card newrt p-4">
            <div>
              <h1 class="head-text" >Your account is blocked.</h1>
              <p class="head-text1" >LookzUp Admin blocked your account due to the following reason:</p>
              <p class="head-text1" style="font-weight: 600;">{{blockedUserData.block_reason}}</p>
            </div>
            <div style="margin: 20px 0px 0px;border-top: 1px solid lightgrey;padding-top: 15px;">
              <p class="">Provide grievance or request unblock.</p>
              <mat-form-field class=" w-100"  style="margin-top: 0px;" appearance="outline" >
                <textarea matInput #input placeholder="Enter your grievance" autocomplete="off" [(ngModel)]="blockedUserGrievance"></textarea>
              </mat-form-field>
            </div>
            <div style="    text-align: right;">
              <button
              style="margin-bottom: 20px;"
              mat-flat-button
              color="accent"
              [disabled]="!blockedUserGrievance"    
              (click)="sendUnblockRequest()"
            >
              Send
            </button>
            </div>
          </mat-card>
          </div>
  
         <!-- mobile start-->
    <div class="login_cardg_wert" *ngIf="registrationDone">
      <mat-card appearance="outlined">
        <div class="login_cardf_secr">
          <h3>Hey, there!</h3>
          <p>Now download the LookzUp Business app from Google Play Store or Apple App Store. Install in your phone,
            login, and start managing your Salon, Parlour, Spa and Make-up Studio.</p>
        
            <div  class="playstore-img">
              <div class="play_store_social d-flex">
                <div  style="margin-right: 15px; margin-top: 12px;">
                  <img src="./assets/images/playstore.png" class="linkImages"></div>
                  <div style="    margin-top: 12px;"><img  src="./assets/images/applestore.png" class="linkImages">
                  </div>
                </div>
            </div>
          </div>
      </mat-card>
      <mat-card appearance="outlined">
        <div class="login_headingty">
          <h3>How LookzUp can help you?</h3>
          <p>This is a dedicated platform for the Beauty and Grooming industry. It manages businesses, bookings, employees, payments, expenditure, customers and promotions. A must have productivity tool for the business owners.</p>
        <div class="featutr_btn">
          <button mat-stroked-button (click)="openBusinessFeatures()">See the features <mat-icon> navigate_next </mat-icon></button>
        </div>
        </div>
      </mat-card>
    </div>
    <!-- mobile end -->
  
        </div>
      </div>
    </div>
  
  
  </div>
  